import { gsap } from 'gsap';
import { initials, enter } from '../animations';

export function gameoverEnter(el) {
  const banner = el.querySelector('.ui-end-game__banner');
  const score = el.querySelector('.ui-end-game__score');
  const share = el.querySelector('.content__share');
  const shareText = share.querySelector('.share-button__caption');
  const shareButton = share.querySelector('.share-button__button');
  const table = el.querySelector('.content__table');
  const roundedButton = el.querySelector('.content__button');
  const tl = gsap.timeline();

  initials.get('fade')(banner);
  initials.get('fade')(score);
  initials.get('fade')(shareText);
  initials.get('circularButton')(shareButton);
  initials.get('fade')(table);
  initials.get('roundedButton')(roundedButton);

  tl.addLabel('start')
    .add(enter.get('fade')(banner), 'start')
    .add(enter.get('fade')(score), 'start+=0.3')
    .add(enter.get('fade')(shareText), 'start+=0.6')
    .add(enter.get('circularButton')(shareButton), 'start+=0.7')
    .add(enter.get('roundedButton')(roundedButton), table ? 'start+=1.3' : 'start+=1');

  if (table) {
    tl.add(enter.get('fade')(table), 'start+=1');
  }
  return tl;
}

export function gameoverLeave(el) {
  const tl = gsap.timeline();

  tl.addLabel('start')
    .to(el, { opacity: 0, ease: 'bloom' });

  return tl;
}
